// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1tl4q","cell":"ColumnAccessor_cell__2F98P","firstCellAccent":"ColumnAccessor_firstCellAccent__34z56"};